(() => {
  function initDiscountScript() {
    const appliedDiscountsContainer = document.getElementById('applied-discounts');
    const applyBtn = document.getElementById('apply-discount-btn');
    const discountInput = document.getElementById('discount-input');

    // Prevent duplicate event listeners
    const container = document.getElementById('discount-code-container');
    if (container && container.dataset.discountScriptInitialized === 'true') return;
    if (container) container.dataset.discountScriptInitialized = 'true';

    if (!appliedDiscountsContainer || !applyBtn || !discountInput) return;

    const strings = window.cartDiscountStrings || {};
    const MSG_NO_CODE = strings.errorNoCode || "Please enter a discount code.";
    const MSG_ALREADY_APPLIED = strings.errorAlreadyApplied || "That discount code is already applied.";
    const MSG_INVALID = strings.errorInvalid || "Discount code is invalid or not applicable.";

    function clearMessages() {
      const errDiv = document.getElementById('discount-error-message');
      if (errDiv) {
        errDiv.style.display = 'none';
        errDiv.textContent = '';
      }
    }

    function showError(msg) {
      const errDiv = document.getElementById('discount-error-message');
      if (errDiv) {
        errDiv.style.display = 'block';
        errDiv.textContent = msg;
      }
    }

    function getCurrentDiscounts() {
      const pills = document.querySelectorAll('#applied-discounts .discount-pill');
      return Array.from(pills).map((pill) => pill.getAttribute('data-code').toUpperCase());
    }

    function triggerCartUpdate() {
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if (cartDrawerItems && typeof cartDrawerItems.updateQuantity === 'function') {
        const qtyInput =
          document.getElementById('Drawer-quantity-1') ||
          document.getElementById('Quantity-1');
        if (qtyInput) {
          const currentQty = parseInt(qtyInput.value, 10) || 1;
          cartDrawerItems.updateQuantity(1, currentQty);
          return;
        } else {
          cartDrawerItems.onCartUpdate();
          return;
        }
      }

      const cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        const qtyInput =
          document.getElementById('Quantity-1') ||
          document.getElementById('Drawer-quantity-1');
        if (qtyInput) {
          const currentQty = parseInt(qtyInput.value, 10) || 1;
          cartItems.updateQuantity(1, currentQty);
          return;
        } else {
          cartItems.onCartUpdate();
          return;
        }
      }
    }

    async function applyDiscounts(discountCodes = []) {
      let isRemoving = false;
      if (discountCodes.length === 0) {
        discountCodes = ['REMOVE_SHOPIFY_CODE'];
        isRemoving = true;
      }
      const discountString = discountCodes.join(',');
      const checkoutUrl = `/checkout?discount=${encodeURIComponent(discountString)}`;

      try {
        await fetch(checkoutUrl, { method: 'GET' });
      } catch (err) {}

      const cartRes = await fetch('/cart.js');
      const cartData = await cartRes.json();

      const validSet = new Set();
      (cartData.cart_level_discount_applications || []).forEach(d => validSet.add(d.title.toUpperCase()));
      cartData.items.forEach(item => {
        (item.line_level_discount_allocations || []).forEach(a => {
          validSet.add(a.discount_application.title.toUpperCase());
        });
      });

      const invalidCodes = discountCodes.filter(c => !validSet.has(c.toUpperCase()));
      const newlyAddedCode = discountCodes[discountCodes.length - 1];
      const codeIsInvalid = invalidCodes.includes(newlyAddedCode);

      if (newlyAddedCode === 'REMOVE_SHOPIFY_CODE' || !codeIsInvalid) {
        triggerCartUpdate();
      }
      return {
        success: !codeIsInvalid || isRemoving,
        invalidCodes
      };
    }

    applyBtn.addEventListener('click', async () => {
      clearMessages();
      const existingCodes = getCurrentDiscounts();
      let newCode = discountInput.value.trim().toUpperCase();
      if (!newCode) {
        showError(MSG_NO_CODE);
        return;
      }
      if (existingCodes.includes(newCode)) {
        showError(MSG_ALREADY_APPLIED);
        return;
      }
      // Start loading animation
      let originalBtnText = applyBtn.textContent;
      let dotCount = 0;
      let loading = true;
      applyBtn.disabled = true;
      const animateDots = () => {
        if (!loading) return;
        dotCount = (dotCount + 1) % 4;
        applyBtn.textContent = originalBtnText + '.'.repeat(dotCount);
        setTimeout(animateDots, 400);
      };
      animateDots();

      const combinedCodes = [...existingCodes, newCode];
      const result = await applyDiscounts(combinedCodes);
      loading = false;
      applyBtn.textContent = originalBtnText;
      applyBtn.disabled = false;
      if (result.invalidCodes.map(c => c.toUpperCase()).includes(newCode)) {
        showError(MSG_INVALID);
      }
    });

    appliedDiscountsContainer.addEventListener('click', async (event) => {
      if (!event.target.closest('.remove-discount')) return;
      clearMessages();
      const pill = event.target.closest('.discount-pill');
      if (!pill) return;
      const codeToRemove = pill.getAttribute('data-code');
      if (!codeToRemove) return;
      const existingCodes = getCurrentDiscounts();
      const newDiscountList = existingCodes.filter(c => c !== codeToRemove.toUpperCase());
      await applyDiscounts(newDiscountList);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initDiscountScript();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      initDiscountScript();
    });
  }

  // MutationObserver to re-initialize when discount code container is added
  const observer = new MutationObserver(() => {
    if (document.getElementById('discount-code-container')) {
      initDiscountScript();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Expose for manual triggering if needed
  window.initDiscountScript = initDiscountScript;
})();
// VELORA: Gratis-Code automatisch beim Socken-Abo anwenden.
(() => {
  if (window.veloraAutoFreeLoaded) return;
  window.veloraAutoFreeLoaded = true;

  const CODE = 'free';
  const PLAN = '692459143497';
  const ROOT = window.Shopify?.routes?.root || '/';
  const OPT_OUT = 'velora-free-removed';
  let timer;
  let busy = false;
  let queued = false;
  let lastAttempt = '';

  function optedOut() {
    try {
      return sessionStorage.getItem(OPT_OUT) === 'yes';
    } catch {
      return false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(checkCart, 350);
  }

  async function checkCart() {
    if (busy) {
      queued = true;
      return;
    }
    if (optedOut()) return;
    busy = true;

    try {
      const response = await fetch(ROOT + 'cart.js', {
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Warenkorb nicht erreichbar.');
      const cart = await response.json();

      const eligible = cart.items.some(item =>
        String(item.selling_plan_allocation?.selling_plan?.id) === PLAN
      );

      if (!eligible) {
        lastAttempt = '';
        return;
      }

      const applications = [
        ...(cart.cart_level_discount_applications || []),
        ...cart.items.flatMap(item =>
          (item.line_level_discount_allocations || [])
            .map(entry => entry.discount_application)
        )
      ];

      const hasFree = applications.some(discount =>
        String(discount.title).toLowerCase() === CODE
      );
      if (hasFree) return;

      // Einen bewusst gewählten anderen Rabatt nicht ersetzen.
      const hasOtherCode = applications.some(discount =>
        discount.type === 'discount_code'
      );
      if (hasOtherCode) return;

      const signature = JSON.stringify(
        cart.items.map(item => [
          item.variant_id,
          item.quantity,
          item.selling_plan_allocation?.selling_plan?.id || null
        ])
      );

      // Verhindert wiederholte Versuche bei abgelehntem Rabatt.
      if (signature === lastAttempt || optedOut()) return;
      lastAttempt = signature;

      const update = await fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: CODE })
      });
      if (!update.ok) throw new Error('Rabatt konnte nicht angewendet werden.');
      await update.json();

      const cartElement =
        document.querySelector('cart-drawer-items') ||
        document.querySelector('cart-items');

      if (typeof cartElement?.onCartUpdate === 'function') {
        await cartElement.onCartUpdate();
      }
    } catch (error) {
      console.warn('VELORA Gratisrabatt:', error);
    } finally {
      busy = false;
      if (queued) {
        queued = false;
        schedule();
      }
    }
  }

  // Entfernen erlauben, etwa für eine bezahlte Wiederanmeldung.
  document.addEventListener('click', event => {
    const remove = event.target.closest?.('.remove-discount');
    const pill = remove?.closest('.discount-pill');
    if (pill?.getAttribute('data-code')?.toLowerCase() === CODE) {
      try {
        sessionStorage.setItem(OPT_OUT, 'yes');
      } catch {}
    }
  }, true);

  function start() {
    if (typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }

    const observer = new MutationObserver(records => {
      if (records.some(record =>
        record.target instanceof Element &&
        record.target.closest('cart-drawer, cart-items')
      )) {
        schedule();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();